import React, {useEffect,useState} from 'react';

import FlashMessages, {FlashMessageData} from './flashMessages.js';
import {getDomain, isForbiddenDomainName} from '../helpers/helpers.js'

// Declare global grecaptcha for reCAPTCHA
declare global {
    const grecaptcha: {
        getResponse(): string;
        reset(): void;
    };
}

interface ErrorMessage {
    msg: string;
}

interface ScanProps {
    errors?: ErrorMessage[];
    success_msg?: string;
    error_msg?: string;
    error?: string;
    ShowCaptcha?: boolean;
}

// interface FlashState {
//     errors?: ErrorMessage[];
//     success_msg?: string;
//     error_msg?: string;
//     error?: string;
// }

interface WebsiteScanFormProps {
    reCaptchaSiteKey?: string;
    props: ScanProps;
    google?: unknown;
    domain?: string;
    readonly?: boolean;
}

interface ScanResponse {
    results?: {
        status: string;
        scanId: string;
    };
    err?: string;
}

export default function WebsiteScanForm({reCaptchaSiteKey, props, google, domain, readonly}: WebsiteScanFormProps) {

    const initialFlashProps: FlashMessageData = {
        errors: props.errors,
        success_msg: props.success_msg,
        error_msg: props.error_msg,
        error: props.error
    }

    const [flashProps, setFlashProps] = useState(initialFlashProps);
    const showCaptcha = props.ShowCaptcha;

    useEffect(() => { 
		return () => {
			let script = document.getElementById('googleCaptchaScript');
			if (script) {
				script.remove();
			}
		}				
	},[google])       
    function SendWebsiteScan(domain: string, deepScan: boolean, captcha?: string): void {
        const requestBody = JSON.stringify({
			domain, deepScan, captcha
        });
        console.log('requestBody:'+JSON.stringify(requestBody));

        fetch(`/technology-scan/api-scan`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: requestBody
        }).then((result) => {
            return result.json();
        }).then((data: ScanResponse) => {
            if (data.results && data.results.status === 'started') { 
				document.location.href = `/technology-scan/results?scanid=${data.results.scanId}`;
            } else {
                console.log(JSON.stringify(data));
                if (data.err){				
                    setFlashProps({error_msg: data.err})
                }
                else {
                    setFlashProps({error_msg: "Unknown error"})
                }
            }
            if (showCaptcha) {
                grecaptcha.reset();
            }
    
        }).catch((e) => {
            console.error("Exception", e);
            setFlashProps({error_msg: "Unknown error"});     
        });
    }   
    function handleSubmit(event: React.FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        const captcha = !!showCaptcha ? grecaptcha.getResponse() : undefined;
        const form = event.currentTarget;
        const domainInput = form.elements.namedItem('domain') as HTMLInputElement;
        const deepScanInput = form.elements.namedItem('deepScan') as HTMLInputElement;
        
		const domain = getDomain(domainInput.value);
		const deepScan = deepScanInput ? deepScanInput.checked : false;

        setFlashProps({});

		if (domain !== null){
			if (isForbiddenDomainName(domain)) {
                setFlashProps({error_msg: "Scanning of this website is not permitted"})
			} else {

                if (showCaptcha && !captcha) {
                    setFlashProps({error_msg: "Please select CAPTCHA"});
                }
                else {
                    SendWebsiteScan(
                        domain,
                        deepScan,
                        captcha);
                }
			}
		} else {
            setFlashProps({error_msg: "Please enter a valid domain name"})
		}
    }
    return (      
        <>    
        <form action='#' method="GET" onSubmit={handleSubmit} >
            <div className="form-group">
                <FlashMessages props={flashProps} />
            </div>
            <div className="form-group">
            <input
                    type="text"
                    id="domain"
                    name="domain"
                    className="form-control"
                    aria-label="Input the domain name to initiate a technology scan."
                    placeholder="Input the domain name to initiate a technology scan."
                    defaultValue={domain}
                    {...(!readonly ? {} : { readOnly: true })}
                />                
            </div>     
            {/**
             * 
					value={domain}
                    {...(!!domain || { readOnly: true })}
                    required
             * 
             */}     
              {/**
            <div className="form-group">
				<input type="checkbox" id="deepScan" name="deepScan"/>
				{' '}
				<label htmlFor="deepScan"> 
				Execute a deep scan (Deep scan may take upto 3 minutes vs 30 seconds for a quick scan)
				</label>
			</div>    */}
            {   !!showCaptcha &&        
                <div className="form-group" style={{ display: "flex" }}>
                                <div style={{ marginLeft: 'auto'}}
                                    className="g-recaptcha" 
                                    id="captcha1"
                                    data-sitekey={reCaptchaSiteKey}>
                                </div>
                </div>   
            }
            <div className="form-group" style={{ display: "flex" }}>
               <button type="submit" className="btn btn-primary text-right" style={{ marginLeft: "auto" }} >Scan Domain</button>
            </div>
        </form>        
    </>
   )
}

